function EditEnvelope(props: any) {
    return (
        <div className={props.className}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M13.7075 16.6021V14.8549L17.4253 11.1333L19.1641 12.8663L15.4462 16.6021H13.7075ZM14.5557 15.7498H15.0928L16.8033 14.0169L16.5489 13.747L16.2803 13.4913L14.5557 15.21V15.7498ZM16.5489 13.747L16.2803 13.4913L16.8033 14.0169L16.5489 13.747Z" fill="currentColor" />
                <path d="M1.66406 16.6641V4.16406H17.2543V10.3945H15.6953V7.28906L9.45918 11.1953L3.22309 7.28906V15.1016H12.5772V16.6641H1.66406ZM9.45918 9.63281L15.6953 5.72656H3.22309L9.45918 9.63281Z" fill="currentColor" />
            </svg>
        </div>
    );
}

export default EditEnvelope;
